import {inject, Service, signal} from '@angular/core'
import {HttpClient} from '@angular/common/http'
import {environment} from '../../environments/environment'
import {Observable, switchMap, take, timer} from 'rxjs'
import {filter, tap} from 'rxjs/operators'
import {ILoan, IOndemandCheckResult, IOndemandPrintRequest} from '@sparbanken-syd/loan-renewal-be'

@Service()
export class OndemandService {
  /**
   * Emit som status here if you want.
   */
  public status$ = signal<'Ledig' | 'Väntar' | 'Kollar'>('Ledig')

  private readonly http = inject(HttpClient)

  public order(ids: string[]): Observable<string> {
    const url = `${environment.dataServiceUrl}/ondemand/create`
    return this.http.put<string>(url, ids)
  }

  public waitForResult(id: string): Observable<IOndemandCheckResult> {
    const url = `${environment.dataServiceUrl}/ondemand/check/${id}`
    return timer(0, 5000)
      .pipe(
        switchMap(() => {
          this.status$.set('Kollar')
          return this.http.get<IOndemandCheckResult>(url)
        }),
        tap(() => this.status$.set('Väntar')),
        filter((res) => res.status === 'COMPLETE'),
        tap(() => this.status$.set('Ledig')),
        take(1)
      )
  }

  public print(request: IOndemandPrintRequest): Observable<any> {
    const url = `${environment.dataServiceUrl}/ondemand/print`
    return this.http.put(url, request)
  }

  public preBound(loan: ILoan, preview = false): Observable<any> {
    const url = `${environment.dataServiceUrl}/ondemand/pre-bound`
    return this.http.put<{ url: string }>(url, {data: loan, preview})
  }
}
